import React from 'react';
import styles from './Paginador.module.css';
import left from '../../assets/img/arrow-left-custom.svg';
import rigth from '../../assets/img/arrow-right-custom.svg';

const Paginador = ({ dadosPagina, acaoMudaPagina }) => {
  if (
    !dadosPagina ||
    (dadosPagina.numberElements === 0 && dadosPagina.first && !dadosPagina.next)
  ) {
    return null;
  }
  const offset = dadosPagina.number * dadosPagina.size;
  const ultimoRegistroPagina = offset + dadosPagina.numberElements;

  function paginaAnterior() {
    if (dadosPagina.previous) acaoMudaPagina(dadosPagina.number - 1);
  }

  function proximaPagina() {
    if (dadosPagina.next) acaoMudaPagina(dadosPagina.number + 1);
  }

  return (
    <div className={styles.acoesTabela}>
      <div className={styles.acoesPaginacao}>
        <span>
          {offset + 1}-{ultimoRegistroPagina}
          {dadosPagina.totalElements ? ` de ${dadosPagina.totalElements}` : ''}
        </span>
        <button className={styles.paginacaoAnterior} onClick={paginaAnterior}>
          <img className="img-card" alt="pagina anterior" src={left} />
        </button>
        <button className={styles.paginacaoProxima} onClick={proximaPagina}>
          <img className="img-card" alt="próxima pagina" src={rigth} />
        </button>
      </div>
    </div>
  );
};

export default Paginador;
